import { AccountContext } from './types';

export type VatDisplay = 'standard' | 'notApplicable' | 'reverseCharge';

export const REVERSE_CHARGE_NOTE =
  '*You are responsible for reporting and paying the correct VAT amount to your local tax authority';

/**
 * Signed in, the school's account decides; otherwise the public flow's chosen location does.
 * A rate of 0 cannot tell a non-EU school from an EU reverse charge, so the rate is not used.
 */
export const vatDisplay = (
  accountContext: AccountContext | null | undefined,
  membershipOptInfo: any
): VatDisplay => {
  if (accountContext) {
    const location = (accountContext.locationName || '').toLowerCase();
    if (location === 'other') return 'notApplicable';
    if (location === 'non-uk eu' && !accountContext.bChargeVAT) return 'reverseCharge';
    return 'standard';
  }

  const info = membershipOptInfo && membershipOptInfo[0];
  if (info && info.vatCode) return 'reverseCharge';
  if (info && info.selectedLocationLabel && info.selectedLocationLabel.toLowerCase() === 'other') {
    return 'notApplicable';
  }
  return 'standard';
};
